// this function allows the animation of the q and a's dropdowns
jQuery(document).ready(function($){
	// if the current page is the faq page
	if( $('#faq_page').length){
		// get the height of each q&a section then apply it as a data attribute to the wrapper for use later
		$('.wrap .q_a').each(function(){
			var height = $(this).outerHeight(true);
			$(this).parent('.wrap').attr('data-height', height);
		});

		// if the window is resized up date the data attributes for the new height and if it is open apply it
		$(window).on('resize', function(){
			$('.wrap .q_a').each(function(){
				var height = $(this).outerHeight(true);
				var wrapper = $(this).parent('.wrap');
				$(this).parent('.wrap').attr('data-height', height);
				
				if( wrapper.hasClass('open') ){
					wrapper.css('max-height', height);
				}
			});
		});

		// apply classes and height to the section which is opened 
		$('.tab').click(function(){
			if(!$(this).hasClass('open')){
				$(this).addClass('open');
				$(this).next('.wrap').addClass('open');
				var data = $(this).next('.wrap').data('height');
				$(this).next('.wrap').css('max-height', data);
			}else{
				$(this).removeClass('open');
				$(this).next('.wrap').removeClass('open');
				$(this).next('.wrap').css('max-height', '0');
			}
		});
	}
});